import { render, staticRenderFns } from "./AverageSpendingPerTicket.vue?vue&type=template&id=42b154c0&scoped=true&"
import script from "./AverageSpendingPerTicket.vue?vue&type=script&lang=js&"
export * from "./AverageSpendingPerTicket.vue?vue&type=script&lang=js&"
import style0 from "./AverageSpendingPerTicket.vue?vue&type=style&index=0&id=42b154c0&scoped=true&lang=css&"
import style1 from "./AverageSpendingPerTicket.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b154c0",
  null
  
)

export default component.exports